import { makeStyles } from '@material-ui/core/styles';

const drawerWidth = 380;

export const useStyles = makeStyles(
  (theme) => (
    {
      drawer: {
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
      },
      drawerOpen: {
        width: drawerWidth,
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
      drawerClose: {
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        overflowX: 'hidden',
        width: theme.spacing(7) + 1,
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9) + 1,
        },
      },
      drawerEnd: {
        flex: 1,
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'end',
      },
      darkMode: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 1),
        justifyContent: 'flex-start',
      },
      toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: theme.spacing(0, 1),
        ...theme.mixins.toolbar,
      },
    }
  )
);

export default useStyles;
